/* eslint-disable @typescript-eslint/naming-convention */
export const ALLOWED_IMAGE_EXTENSIONS: string[] = ['jpg', 'jpeg', 'png', 'heif', 'heic']
export const ALLOWED_IMAGE_MIME_TYPE: string[] = ['image/png', 'image/jpeg', 'image/heif', 'image/heic']
export const ALLOWED_FILE_MIME_TYPE: string[] = ['application/pdf']
export const ALLOWED_FILE_EXTENSIONS: string[] = ['pdf']
export const MAX_FILE_SIZE_ALLOWED: number = 1024 * 1024 * 15 // 15MB
